import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export const PageContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: 40
}));

export const PageHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(3)
}));

export const DeclarationList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export const EmptyStateText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2R,
  color: theme.palette.brand.darkGreen,
  textAlign: 'center',
  padding: `${theme.spacing(2)} 0`
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1R,
  marginBottom: theme.spacing(3)
}));

export const DisclaimerBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutrals.beige2,
  borderRadius: 8,
  padding: theme.spacing(1.5),
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(5)
}));

export const DisclaimerText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2B,
  lineHeight: 1.5,
  fontWeight: 600,
  textAlign: 'center'
}));

export const WhatsAppRow = styled(Box)(() => ({
  textAlign: 'center'
}));
